import { useNavigate, useLocation } from 'react-router-dom'

const tabs = [
  {
    path: '/',
    label: 'Home',
    icon: (active) => (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--fp-red)' : 'var(--fp-text-dim)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    path: '/watchlist',
    label: 'Watchlist',
    icon: (active) => (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--fp-red)' : 'var(--fp-text-dim)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
        <line x1="7" y1="2" x2="7" y2="22" />
        <line x1="17" y1="2" x2="17" y2="22" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <line x1="2" y1="7" x2="7" y2="7" />
        <line x1="2" y1="17" x2="7" y2="17" />
        <line x1="17" y1="7" x2="22" y2="7" />
        <line x1="17" y1="17" x2="22" y2="17" />
      </svg>
    ),
  },
  {
    path: '/history',
    label: 'History',
    icon: (active) => (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--fp-red)' : 'var(--fp-text-dim)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    path: '/group',
    label: 'Groups',
    icon: (active) => (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={active ? 'var(--fp-red)' : 'var(--fp-text-dim)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87" />
        <path d="M16 3.13a4 4 0 010 7.75" />
      </svg>
    ),
  },
]

export default function TabBar() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <>
      {/* Fade-out mask above the tab bar — kills the "content bleeds through
          a translucent footer" look when scroll position parks mid-section. */}
      <div
        className="fixed left-0 right-0 pointer-events-none z-40"
        style={{
          bottom: 'calc(env(safe-area-inset-bottom, 16px) + 74px)',
          height: '32px',
          background: 'linear-gradient(to top, var(--fp-bg), rgba(0, 0, 0, 0))',
        }}
      />
    <nav
      className="fixed bottom-0 left-0 right-0 flex border-t border-[var(--fp-border)] z-50"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom, 16px)',
        background: 'var(--fp-bg)',
      }}
    >
      {tabs.map(tab => {
        const active = location.pathname === tab.path ||
                       (tab.path === '/watchlist' && location.pathname === '/add')
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className="flex-1 flex flex-col items-center gap-1.5 bg-transparent border-none cursor-pointer"
            style={{ paddingTop: '14px', paddingBottom: '10px' }}
          >
            {tab.icon(active)}
            <span
              className="font-medium"
              style={{
                fontSize: '11px',
                letterSpacing: '0.02em',
                color: active ? 'var(--fp-red)' : 'var(--fp-text-dim)',
              }}
            >
              {tab.label}
            </span>
          </button>
        )
      })}
    </nav>
    </>
  )
}
